import FranceIcon from "components/Icons/FlagsIcons/FranceIcon";
import IndonesiaIcon from "components/Icons/FlagsIcons/IndonesiaIcon";
import IrelandIcon from "components/Icons/FlagsIcons/IrelandIcon";
import ItalyIcon from "components/Icons/FlagsIcons/ItalyIcon";
import NetherlandsIcon from "components/Icons/FlagsIcons/NetherlandsIcon";
import PolandIcon from "components/Icons/FlagsIcons/PolandIcon";
import RomaniaIcon from "components/Icons/FlagsIcons/RomaniaIcon";
import SaudiArbiaIcon from "components/Icons/FlagsIcons/SaudiArbiaIcon";
import TurkeyIcon from "components/Icons/FlagsIcons/TurkeyIcon";
import UkraineIcon from "components/Icons/FlagsIcons/UkraineIcon";
import UsIcon from "components/Icons/FlagsIcons/UsIcon";
import SpainIcon from "components/Icons/FlagsIcons/SpainIcon";
import SerbiaIcon from "components/Icons/FlagsIcons/SerbianIcon";
import ChineseIcon from "components/Icons/FlagsIcons/ChineseIcon";
import PilipinasIcon from "components/Icons/FlagsIcons/PilipinasIcon";
import IsraelIcon from "components/Icons/FlagsIcons/IsraelIcon";


import art_design from "components/Icons/AppCategory/art_design.jpg";
import auto_vehicles from "components/Icons/AppCategory/auto_vehicles.jpg";
import beauty from "components/Icons/AppCategory/beauty.jpg";
import books_reference from "components/Icons/AppCategory/books_reference.jpg";
import business from "components/Icons/AppCategory/business.jpg";
import comics from "components/Icons/AppCategory/comics.jpg";
import communication from "components/Icons/AppCategory/communication.jpg";
import dating from "components/Icons/AppCategory/dating.jpg";
import education from "components/Icons/AppCategory/education.jpg";
import entertainment from "components/Icons/AppCategory/entertainment.jpg";
import events from "components/Icons/AppCategory/events.jpg";
import finance from "components/Icons/AppCategory/finance.jpg";
import food_drink from "components/Icons/AppCategory/food_drink.jpg";
import game from "components/Icons/AppCategory/game.jpg";
import health_fitness from "components/Icons/AppCategory/health_fitness.jpg";
import house_home from "components/Icons/AppCategory/house_home.jpg";
import libraries_demo from "components/Icons/AppCategory/libraries_demo.jpg";
import lifestyle from "components/Icons/AppCategory/lifestyle.jpg";
import maps_navigation from "components/Icons/AppCategory/maps_navigation.jpg";
import medical from "components/Icons/AppCategory/medical.jpg";
import music from "components/Icons/AppCategory/music.jpg";
import news_magazines from "components/Icons/AppCategory/news_magazines.jpg";
import parenting from "components/Icons/AppCategory/parenting.jpg";
import personalization from "components/Icons/AppCategory/personalization.jpg";
import photography from "components/Icons/AppCategory/photography.jpg";
import productivity from "components/Icons/AppCategory/productivity.jpg";
import shopping from "components/Icons/AppCategory/shopping.jpg";
import social from "components/Icons/AppCategory/social.jpg";
import sports from "components/Icons/AppCategory/sports.jpg";
import tools from "components/Icons/AppCategory/tools.jpg";
import travel_local from "components/Icons/AppCategory/travel_local.jpg";
import video_players_editors from "components/Icons/AppCategory/video_players_editors.jpg";
import weather from "components/Icons/AppCategory/weather.jpg";

export const COLOR_THEME_MODE = [
  { title: "Light", value: "light" },
  { title: "Dark", value: "dark" },
  { title: "Yellow", value: "yellow" },
  { title: "Pink", value: "pink" },
];

export const LANGUAGE_DROPDOWN = [
  { title: "English", value: "en", icon: <UsIcon /> },
  { title: "Polski", value: "pl", icon: <PolandIcon /> },
  { title: "Italian", value: "it", icon: <ItalyIcon /> },
  { title: "Indonesia", value: "id", icon: <IndonesiaIcon /> },
  { title: "Española", value: "sp", icon: <SpainIcon />},
  { title: "Română", value: "ro", icon: <RomaniaIcon /> },
  { title: "українська", value: "uk", icon: <UkraineIcon /> },
  { title: "српски", value: "sr", icon: <SerbiaIcon /> },
  { title: "Gaeilge", value: "ga", icon: <IrelandIcon /> },
  { title: "Français", value: "fr", icon: <FranceIcon /> },
  { title: "Nederlands", value: "nl", icon: <NetherlandsIcon /> },
  { title: "العربية", value: "ar", icon: <SaudiArbiaIcon /> },
  { title: "Türkçe", value: "tr", icon: <TurkeyIcon /> },
  { title: "עברית", value: "il", icon: <IsraelIcon /> },
  { title: "Pilipinas", value: "fl", icon: <PilipinasIcon /> },
  { title: "中文", value: "ch", icon: <ChineseIcon /> },
];

export const APP_CATEGORY = [
  {
    category: "Books & Reference",
    name: "",
    image: books_reference,
  },
  {
    category: "Entertainment",
    name: "Themes,Sony LIV",
    image: entertainment,
  },
  {
    category: "Sports",
    name: "",
    image: sports,
  },
  {
    category: "Tools",
    name: "EX File Manager,Avast Mobile Security,Secure VPN,Files by Google,Data Restore Tool,Digital Wellbeing,Phone,Google Play services,Google,Gboard,Android Accessibility Suite,Speech Recognition and Synthesis from Google,Android System WebView,ARCore,Lens,Kidslox,Internet Blocker,EasyShare",
    image: tools,
  },
  {
    category: "Auto & Vehicles",
    name: "Android Auto",
    image: auto_vehicles,
  },
  {
    category: "Finance",
    name: "CRED,PhonePe",
    image: finance,
  },
  {
    category: "Video Players & Editors",
    name: "Google TV,YouTube",
    image: video_players_editors,
  },
  {
    category: "Education",
    name: "BYJU'S The Learning App",
    image: education,
  },
  {
    category: "Music",
    name: "Google Podcasts,YouTube Music,Spotify",
    image: music,
  },
  {
    category: "Social",
    name: "Josh,Facebook,Moj Lite +,ShareChat,Moj,TiFamily",
    image: social,
  },
  {
    category: "Libraries & Demo",
    name: "",
    image: libraries_demo,
  },
  {
    category: "Shopping",
    name: "vivo.com,Amazon",
    image: shopping,
  },
  {
    category: "Medical",
    name: "",
    image: medical,
  },
  {
    category: "Personalization",
    name: "",
    image: personalization,
  },
  {
    category: "Game",
    name: "Royal Match,Pilot Simulator: Airplane Game,Tile Master 3D,Candy Crush Saga,Rolling Twins",
    image: game,
  },
  {
    category: "Maps & Navigation",
    name: "",
    image: maps_navigation,
  },
  {
    category: "Business",
    name: "LinkedIn",
    image: business,
  },
  {
    category: "Communication",
    name: "Chrome,Messenger,Messages,Meet,Gmail,AdvanceSMS,Calculator,Snapchat,Truecaller,Viber,Browser,WhatsApp,Signal",
    image: communication,
  },
  {
    category: "Health & Fitness",
    name: "",
    image: health_fitness,
  },
  {
    category: "Food & Drink",
    name: "",
    image: food_drink,
  },
  {
    category: "News & Magazines",
    name: "Dailyhunt,Google News",
    image: news_magazines,
  },
  {
    category: "Travel & Local",
    name: "Maps",
    image: travel_local,
  },
  {
    category: "Photography",
    name: "Photos",
    image: photography,
  },
  {
    category: "Weather",
    name: "",
    image: weather,
  },
  {
    category: "Productivity",
    name: "Drive,Docs,Sheets,Slides,Assistant,Google One,Calendar,MyJio",
    image: productivity,
  },
  {
    category: "Dating",
    name: "",
    image: dating,
  },
  {
    category: "Lifestyle",
    name: "Life360,Qustodio Kids",
    image: lifestyle,
  },
  {
    category: "House & Home",
    name: "",
    image: house_home,
  },
  {
    category: "Art & Design",
    name: "",
    image: art_design,
  },
  {
    category: "Events",
    name: "",
    image: events,
  },
  {
    category: "Comics",
    name: "",
    image: comics,
  },
  {
    category: "Beauty",
    name: "",
    image: beauty,
  },
  {
    category: "Parenting",
    name: "",
    image: parenting,
  },
];


export const SMS_COMMAND_DATA = [
  {
    id: 1,
    code: "LC",
    commandFor: "livelocation",
    subtext: "",
    goal: "viewCurrentLocation",
    result: "locationLinkResponse",
  },
  {
    id: 2,
    code: "PC",
    commandFor: "maincameraphoto",
    subtext: "",
    goal: "accessMainCameraPhoto",
    result: "Picture will be uploaded to TiSPY Scheduler page.",
  },
  {
    id: 3,
    code: "PC 10",
    commandFor: "frontcameraphoto",
    subtext: "",
    goal: "accessFrontCameraPhoto",
    result: "Picture will be uploaded to TiSPY Scheduler page.",
  },
  {
    id: 4,
    code: "AC 20",
    commandFor: "captureaudio",
    subtext: "",
    goal: "captureaudio",
    result:"uploadAudioToScheduler"
  },
  {
    id: 5,
    code: "TNO",
    commandFor: "startwifi",
    subtext: "",
    goal: "startWiFiForcefully",
    result: "startWiFiMonitoringPhone",
  },
  {
    id: 6,
    code: "TNF",
    commandFor: "stopwifi",
    subtext: "",
    goal: "stopWiFiForcefully",
    result: "stopWiFiMonitoringPhone",
  },
  {
    id: 7,
    code: "PR",
    commandFor: "playring",
    subtext: "",
    goal: "playRingCommand",
    result: "-",
  },
  {
    id: 8,
    code: "SC 1",
    commandFor: "synccontact",
    subtext: "",
    goal: "synccontact",
    result: "-",
  },
  {
    id: 9,
    code: "DC 1",
    commandFor: "disablecamera",
    subtext: "",
    goal: "disablecamera",
    result: "-",
  },
  {
    id: 10,
    code: "DC 0",
    commandFor: "enablecamera",
    subtext: "",
    goal: "enablecamera",
    result: "-",
  },
  {
    id: 11,
    code: "LOCK",
    commandFor: "changescreenlockpassword",
    subtext: "NewPassword",
    goal: "changeLocknewpassword",
    result: "-",
  },
  {
    id: 12,
    code: "CB",
    commandFor: "CALL BACK",
    subtext: "9999999999",
    goal: 'To Call back to 9999999999 number. After sending this command, monitoring phone will call "9999999999".Change 9999999999 with the cell number which you want to be called.',
    result: "-",
  },
  {
    id: 13,
    code: "FQ",
    commandFor: "RESET FILES",
    subtext: "",
    goal: "Remove all files and records which are not uploaded.	",
    result:
      "useCommandForUploadDelay",
  },
];

// Serbian and  Arabic language pending mapping
export const countryToLanguageMap = {
  US: "en",
  FR: "fr",
  ES: "sp",
  FL: "de",
  NL: "nl",
  PL: "pl",
  SR: "sr",
  TR: "tr",
  HK: "ch",
  IE: "ga",
  IT: "it",
  ID: "id",
  RO: "ro",
  UA: "uk",
  IL:"il",
  PH: "fl",
  CN: "ch",
};

export const Smscommmandcode = ["LC", "PC", "PC 1", "PC 10 ", " AC 20", "TNO", "TNF", "PR", "SC 1", " DC 1 ", "DC 0 ", "LOCK", "CB", "FQ"];

export const monthTranslations = {
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
  fr: ["Janv", "Févr", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"],
  nl: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sept", "Okt", "Nov", "Dec"],
  pl: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
  sr: ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"],
  tr: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
  it: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
  id: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"],
  ro: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"],
  uk: ["Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
  ar: ["ينا", "فبر", "مار", "أبر", "ماي", "يون", "يول", "أغس", "سبت", "أكت", "نوف", "ديس"],
  sp: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sept", "Oct", "Nov", "Dic"],
  ga: ["Ean", "Feabh", "Márta", "Aib", "Beal", "Meith", "Iúil", "Lún", "MFómh", "DFómh", "Samh", "Noll"],
  fl: ["Ene", "Peb", "Mar", "Abr", "May", "Hun", "Hul", "Ago", "Set", "Okt", "Nob", "Dis"],
  ch: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
  il: ["ינו", "פבר", "מרץ", "אפר", "מאי", "יונ", "יול", "אוג", "ספט", "אוק", "נוב", "דצמ"],
};

// Day translations
export const dayTranslations = {
  en: {
    today: "Today",
    yesterday: "Yesterday"
  },
  fr: {
    today: "Aujourd'hui",
    yesterday: "Hier"
  },
  nl: {
    today: "Vandaag",
    yesterday: "Gisteren"
  },
  pl: {
    today: "Dziś",
    yesterday: "Wczoraj"
  },
  sr: {
    today: "Danas",
    yesterday: "Juče"
  },
  tr: {
    today: "Bugün",
    yesterday: "Dün"
  },
  it: {
    today: "Oggi",
    yesterday: "Ieri"
  },
  id: {
    today: "Hari ini",
    yesterday: "Kemarin"
  },
  ro: {
    today: "Astăzi",
    yesterday: "Ieri"
  },
  uk: {
    today: "Сьогодні",
    yesterday: "Вчора"
  },
  ar: {
    today: "اليوم",
    yesterday: "أمس"
  },
  sp: {
    today: "Hoy",
    yesterday: "Ayer"
  },
  ga: {
    today: "Inniu",
    yesterday: "Inné"
  },
  fl: {
    today: "Ngayon",
    yesterday: "Kahapon"
  },
  ch: {
    today: "今天",
    yesterday: "昨天"
  },
  il: {
    today: "היום",
    yesterday: "אתמול"
  }
};